import { readTickedKeys } from '../../utils/toggle-map.util';

/**
 * `<value>.entry.settings['rdw-visible-fields']` off a linked-entry-shaped value. Both a company
 * envelope on the form (a synced link field) and `UserStore.currentCompanyEntry()` (a plain Entry)
 * carry the same `{ entry: { settings } }` shape. Returns the raw stored value; normalising it is
 * `readRdwVisibleFieldKeys`'s job.
 */
export function rdwVisibleFieldSettingOf(source: unknown): unknown {
  const entry = (source as Record<string, unknown> | undefined)?.['entry'] as Record<string, unknown> | undefined;
  const settings = entry?.['settings'] as Record<string, unknown> | undefined;
  return settings?.['rdw-visible-fields'];
}

/**
 * Normalises a raw `rdw-visible-fields` value into a key array, or null when nothing usable is
 * there: the current shape is a string array; the legacy form-builder toggle shape is an object
 * whose ticked keys hold true or the string 'true' (toggle fields store their value as a string).
 * The reading itself is shared with the viewer-company conditions (`toggle-map.util.ts`), which
 * read this same setting, so the preview and the conditions cannot disagree about it.
 */
export function readRdwVisibleFieldKeys(raw: unknown): string[] | null {
  return readTickedKeys(raw);
}

/**
 * Keys the RDW preview may show, or null for "show every mapped field": the logged-in user's own
 * company setting. It is the VIEWER's company that decides, not the company the vehicle belongs to
 * (#21461 follow-up) — a carrier and a planner looking at the same vehicle each see the facts their
 * own company ticked. No company, or no usable setting, reads as "show everything".
 */
export function resolveRdwVisibleKeys(userCompany: unknown): string[] | null {
  return readRdwVisibleFieldKeys(rdwVisibleFieldSettingOf(userCompany));
}
